const ENV_URL = process.env.REACT_APP_BACKEND_URL;
const bareHost = (h) => h.replace(/^www\./, "");

// Use same origin when env URL is the apex/www variant of the current host (avoids cross-origin redirects)
const resolve = () => {
  if (typeof window === "undefined") return ENV_URL;
  try {
    const envHost = new URL(ENV_URL).host;
    if (bareHost(envHost) === bareHost(window.location.host)) return window.location.origin;
  } catch (e) {}
  return ENV_URL;
};

export const BACKEND_URL = resolve();
